export const WABA_CONNECT_RESULT_KEY = "wabaConnectResult";
export const ALREADY_CONNECTED_TITLE = "This number is already connected";

export function alreadyConnectedMessage(number) {
  const label = number ? ` (${number})` : "";
  return `This WhatsApp number${label} is already connected to another account on this platform. Disconnect it from that account first, then try connecting it here. One number can only belong to one workspace — it cannot be added again while it is still connected elsewhere.`;
}

function alreadyConnectedFailures(data) {
  const failures = data?.aisensyFailures || data?.webhookFailures || [];
  return failures.filter((f) => f.error_code === "ALREADY_CONNECTED");
}

function alreadyConnectedSteps(failures) {
  return failures.map((f) => ({
    step: "already_connected",
    status: "failed",
    label: f.error_title || ALREADY_CONNECTED_TITLE,
    message: f.error || alreadyConnectedMessage(f.number),
  }));
}

/** Page banner payload from an embedded-signup API body (success or error). */
export function connectResultFromSignupPayload(data) {
  if (!data) {
    return {
      type: "error",
      title: "Could not connect WhatsApp",
      message: "Failed to complete onboarding. Please try again.",
    };
  }

  const already = alreadyConnectedFailures(data);
  const processedCount = data.processed?.length || 0;
  const blockedOnly =
    data.error_code === "ALREADY_CONNECTED" ||
    (already.length > 0 && processedCount === 0);

  if (blockedOnly) {
    return {
      type: "error",
      title: data.error_title || ALREADY_CONNECTED_TITLE,
      message: data.message || alreadyConnectedMessage(already[0]?.number),
      setupSteps: alreadyConnectedSteps(already),
    };
  }

  return null;
}

export function stashWabaConnectResult(result) {
  try {
    sessionStorage.setItem(WABA_CONNECT_RESULT_KEY, JSON.stringify(result));
  } catch (_) {
    /* private mode */
  }
  window.dispatchEvent(new CustomEvent("wabaConnectResult", { detail: result }));
}

export function takeStashedWabaConnectResult() {
  try {
    const raw = sessionStorage.getItem(WABA_CONNECT_RESULT_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(WABA_CONNECT_RESULT_KEY);
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
}
